import { render, staticRenderFns } from "./SavedQueryList.vue?vue&type=template&id=20fa764a&scoped=true&"
import script from "./SavedQueryList.vue?vue&type=script&lang=js&"
export * from "./SavedQueryList.vue?vue&type=script&lang=js&"
import style0 from "./SavedQueryList.vue?vue&type=style&index=0&id=20fa764a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa764a",
  null
  
)

export default component.exports